import React, { useState } from "react";

interface IinitialPlaqueState {
  firstNumber: {
    1: string;
    2: string;
  };
  letter: string;
  secondNumber: {
    1: string;
    2: string;
    3: string;
  };
  iranNumber: {
    1: string;
    2: string;
  };
}
// useForm functional component
export const usePlaqueForm = (
  callback: any,
  initialState: IinitialPlaqueState,
  setErrors: any,
  firstNumber1Ref: any,
  firstNumber2Ref: any,
  inputLetterRef: any,
  secondNumber1Ref: any,
  secondNumber2Ref: any,
  secondNumber3Ref: any,
  iranNumber1Ref: any,
  iranNumber2Ref: any
) => {
  const [plaqueValues, setPlaqueValues] = useState(initialState);
  let goToPriew = false;

  // onPress
  const onPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let mainKey = event.key;
    let persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

    if (persianNumbers.includes(event.key)) {
      mainKey = persianNumbers.indexOf(event.key).toString();
    }

    let keys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    if (!keys.includes(mainKey)) {
      return event.preventDefault();
    }
  };

  const onIranNumber1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    // console.log(event.target.value.length);
    setPlaqueValues({
      ...plaqueValues,
      iranNumber: {
        ...plaqueValues.iranNumber,
        1: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      iranNumber2Ref.current.focus();
    }
  };

  const onUpIranNumber1 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // console.log(iranNumber1Ref.current.value);
    const keyCode = event.which || event.keyCode;

    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        secondNumber3Ref.current.focus();
        secondNumber3Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  const onIranNumber2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      iranNumber: {
        ...plaqueValues.iranNumber,
        2: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      iranNumber2Ref.current.blur();
    }
  };

  const onUpIranNumber2 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        iranNumber1Ref.current.focus();
        iranNumber1Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  const onSecondNumber1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      secondNumber: {
        ...plaqueValues.secondNumber,
        1: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      secondNumber2Ref.current.focus();
    }
  };

  const onUpSecondNumber1 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        firstNumber2Ref.current.focus();
        firstNumber2Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  const onSecondNumber2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      secondNumber: {
        ...plaqueValues.secondNumber,
        2: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      secondNumber3Ref.current.focus();
    }
  };

  const onUpSecondNumber2 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        secondNumber1Ref.current.focus();
        secondNumber1Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  const onSecondNumber3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      secondNumber: {
        ...plaqueValues.secondNumber,
        3: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      iranNumber1Ref.current.focus();
    }
  };

  const onUpSecondNumber3 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        secondNumber2Ref.current.focus();
        secondNumber2Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  const onLetterChange = (item: string) => {
    secondNumber1Ref.current.focus();
    setPlaqueValues({
      ...plaqueValues,
      letter: item,
    });
  };

  const onFirstNumber1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      firstNumber: {
        ...plaqueValues.firstNumber,
        1: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      firstNumber2Ref.current.focus();
    }
  };

  const onFirstNumber2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPlaqueValues({
      ...plaqueValues,
      firstNumber: {
        ...plaqueValues.firstNumber,
        2: event.target.value,
      },
    });

    if (event.target.value.length === 1) {
      inputLetterRef.current.focus();
    }
  };

  const onUpFirstNumber2 = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 8 || keyCode === 46) {
      if (goToPriew) {
        firstNumber1Ref.current.focus();
        firstNumber1Ref.current.select();
        goToPriew = false;
      }
      goToPriew = true;
      return false;
    }
    return false;
  };

  // onSubmit
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await callback(); // triggering the callback
  };

  // return values
  return {
    onIranNumber1,
    onUpIranNumber1,
    onIranNumber2,
    onUpIranNumber2,
    onSecondNumber1,
    onUpSecondNumber1,
    onSecondNumber2,
    onUpSecondNumber2,
    onSecondNumber3,
    onUpSecondNumber3,
    onLetterChange,
    onFirstNumber1,
    onFirstNumber2,
    onUpFirstNumber2,
    onSubmit,
    onPress,
    plaqueValues,
  };
};
